import { Link } from 'react-router-dom';
import type { Comic } from '@/types/comic';
import { formatPopularity, getCategoryById } from '@/lib/comics';

interface ComicCardProps {
  comic: Comic;
  showAuthor?: boolean;
}

export default function ComicCard({ comic, showAuthor = false }: ComicCardProps) {
  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title} 韩漫漫画封面`}
          title={`${comic.title} 韩漫漫画在线看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span
          className={`absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-label font-medium ${
            comic.status === '连载'
              ? 'bg-primary-500 text-background-50'
              : 'bg-accent-600 text-background-50'
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-label">
          <i className="ri-fire-line text-accent-300"></i>
          {formatPopularity(comic.popularity)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-heading font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        {showAuthor && <p className="mt-1 text-xs text-foreground-500 truncate">{comic.author}</p>}
        <p className="mt-1 text-xs text-foreground-600 truncate">{comic.latestChapter}</p>
        <div className="mt-2 flex items-center justify-between">
          <span className="text-xs text-accent-700 font-label font-medium truncate">
            {getCategoryById(comic.categories[0])?.name ?? '漫画'}
          </span>
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-star-fill text-primary-400"></i>
            {comic.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </Link>
  );
}